import React from "react";
import { Card, Badge, ListGroup, Row, Col } from "react-bootstrap";

// Tarjeta resumen de una plantilla
const PlantillaCard = ({ plantilla }) => {
  if (!plantilla) return null;
  return (
    <Card>
      <Card.Header className="bg-dark text-white">
        <Row>
          <Col><strong>{plantilla.codigo}</strong> - {plantilla.descripcion}</Col>
          <Col className="text-end"><Badge bg={(plantilla.estado === "activo" || plantilla.activo) ? "success" : "secondary"}>{(plantilla.estado === "activo" || plantilla.activo) ? "activo" : "inactivo"}</Badge></Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Card.Title>Magnitudes configuradas</Card.Title>
        <ListGroup>
          {(plantilla.magnitudesConfig || []).map((m, i) => (
            <ListGroup.Item key={i}>
              <div className="d-flex justify-content-between">
                <div>
                  <strong>{m.nombre}</strong> — {m.unidad}
                </div>
                <div>
                  <Badge bg="info" className="me-1">Puntos: {m.cantPuntos}</Badge>
                  <Badge bg="info" className="me-1">Med/punto: {m.cantMedicionesPorPunto}</Badge>
                  {m.requiereEstabilidad && <Badge bg="warning">Estabilidad: {m.cantMedicionesEstabilidad}</Badge>}
                </div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default PlantillaCard;
